import React from "react";
import Layout from "../../common/components/Layout";
import EmployeeLeaveTable from "../../common/components/EmployeeLeaveTable";

const LeaveManagement = () => {
  return (
    <Layout>
      {/* maxWidth: '100%' ensures it fills the width of the screen.
          px-lg-5 adds nice breathing room on larger monitors.
      */}
      <div
        className="container-fluid py-4 flex-grow-1 px-lg-5"
        style={{ width: "100%" }}
      >
        {/* EmployeeTable now contains its own glass container logic */}
        
        <EmployeeLeaveTable />
      </div>
    </Layout>
  );
};

export default LeaveManagement;
